<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getCategoryRoute } from '@shopware/helpers'

const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)

defineProps<{
    item: Schemas["Category"]
}>()

defineEmits(['navigate'])
</script>

<template>
    <FoundationLink
        v-if="!item.children.length"
        :href="formatLink(getCategoryRoute(item))"
        itemprop="url"
        :class="{'uppercase font-bold' : item.level === 3}"
        @click="$emit('navigate')"
    >
        {{ item.name }}
    </FoundationLink>

    <div v-else class="flex flex-col gap-1">
        <FoundationLink
            :href="formatLink(getCategoryRoute(item))"
            class="text-neutral font-bold uppercase"
            @click="$emit('navigate')"
        >
            {{ item.name }}
        </FoundationLink>

        <div v-if="item.children.length" class="flex flex-col gap-1">
            <MegaMenuItem
                v-for="childItem in item.children"
                :key="childItem.id"
                :item="childItem"
                class="font-normal text-neutral"
                itemprop="url"
                @click="$emit('navigate')"
                @navigate="$emit('navigate')"
            />
        </div>
    </div>
</template>
